module.exports = __webpack_public_path__ + "img/bot_cye.6fdf1794.png";